var outputAlphaOpaquePS = `
	gl_FragColor.a = 1.0;
`;

export { outputAlphaOpaquePS as default };
